export default __webpack_public_path__ + "static/media/ProWa.047d69a8.jpg";